var map = {
	"./code/BakeMate.jpg": 9859,
	"./code/ChatApp.png": 5572,
	"./code/SEO Parser.png": 9311,
	"./code/cpp.png": 4928,
	"./code/dsap1.png": 7750,
	"./code/dsap2.png": 9373,
	"./code/emphd.png": 4241,
	"./code/floorMe.jpg": 3151,
	"./code/infoCasestudy.jpg": 8064,
	"./code/pyodbc.png": 4422,
	"./code/r2h.png": 767,
	"./code/stk.jpg": 5423,
	"./food/1.jpg": 6549,
	"./food/10.jpg": 6489,
	"./food/2.jpg": 9322,
	"./food/3.jpg": 1255,
	"./food/4.jpg": 1020,
	"./food/5.jpg": 8809,
	"./food/6.jpg": 7310,
	"./food/7.jpg": 7467,
	"./food/8.jpg": 2160,
	"./food/9.jpg": 253,
	"./food/AppleCheesecake.png": 5391,
	"./food/CherCk.png": 9648,
	"./food/Strawberry Shortcake.png": 4875,
	"./food/bchic.png": 2263,
	"./food/cookies.png": 7481,
	"./food/gramen.png": 5346,
	"./food/stcsc.png": 8726,
	"./food/tira.png": 1340,
	"./food/tofu.png": 4098,
	"./food/wcstrck.png": 3037,
	"./me1.jpg": 9566,
	"./ope.png": 9787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5641;